package com.nonopn.skydome.common.app.pages.estimate

import kotlinx.serialization.Serializable

@Suppress("MagicNumber")
class EstimatePriceComputation {
    private val pricePerProbe = 65

    val tiers = listOf(
        2 to 20,
        3 to 30,
        6 to 40,
        10 to 50,
    )

    fun compute(existingCount: Int, newCount: Int): EstimatePriceEstimation {
        val totalCount = existingCount + newCount

        val discount = tiers.reversed()
            .firstOrNull { it.first <= totalCount }?.second ?: 0

        val nextTier = tiers.firstOrNull { it.first > totalCount }

        return EstimatePriceEstimation(
            regular = pricePerProbe * newCount,
            price = pricePerProbe * newCount * (100 - discount) / 100,
            discount = discount,
            existingCount = existingCount,
            newCount = newCount,
            totalCount = totalCount,
            nextTierThreshold = nextTier?.first,
            nextTierDiscount = nextTier?.second,
        )
    }
}

@Serializable
data class EstimatePriceEstimation(
    val regular: Int,
    val discount: Int,
    val price: Int,
    val existingCount: Int = 0,
    val newCount: Int = 0,
    val totalCount: Int = 0,
    val nextTierThreshold: Int? = null,
    val nextTierDiscount: Int? = null,
)
